module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_jordan_07.fc40c8a8.jpg";